<script>
import { mapState, mapActions } from 'vuex';
import { Dialog } from 'mand-mobile';
import { transNumber } from '@utils/trans';
import { getShortDeductMoney, getVideoDeductMoney, postAddVipVideo } from '@api/mine';

export default {
  name: 'videoTips',
  props: {
    item: {
      type: Object,
      default: () => {}
    },
    type: {
      type: String,
      default: () => 'home'
    },
    isGroup: {
      type: Number,
      default: () => 0
    },
    videoType: {
      type: String,
      default: () => 'short'
    }
    /*    currentVideoPlayer: {
      type: HTMLVideoElement,
      default: () => ({})
    } */
  },
  data () {
    return {
      list: []
    };
  },
  computed: {
    ...mapState('user', ['userInfo', 'walletInfo']),
    limit () {
      const userUid = transNumber(this.userInfo.uid);
      if (userUid === this.item.uid) return [];

      const userVip = transNumber(this.userInfo.is_vip);
      const videoCount = transNumber(this.userInfo.video_count);

      //  是否是付费视频,1:是，2:不是
      const isMoney = 'is_money' in this.item ? this.item.is_money : 0;
      //  vip观看视频，1:是，2:不是
      const isVip = 'is_vip' in this.item ? this.item.is_vip : 0;
      //  认证视频
      const isPublic = this.item.is_public ? this.item.is_public : 1;
      // 付费视频的金币数量
      const money = 'money' in this.item ? transNumber(this.item.money) : 0;
      //  用户余额
      const balance = transNumber(this.walletInfo.balance);

      const isAuth = isPublic === 3 || this.type === 'authentication';
      if (isAuth) {
        if (this.isGroup === 1 || isMoney === 3) {
          return [];
        }
        if (this.isGroup === 2) {
          if (isMoney === 1) {
            return balance < money ? ['group', 'money'] : ['group', 'deposit'];
          }
          return ['group'];
        }
      }
      //  付费视频并且不是VIP：isMoney === 1,查看用户是否有免费观看的权限，true：没有，false: 有
      if (isMoney === 1 && isVip !== 1) {
        if (money === 0) {
          return [];
        }
        if (videoCount > 0) {
          return ['right'];
        }
        return balance < money ? ['money'] : ['deposit'];
      } else if (isVip === 1 && isMoney !== 1) {
        return userVip !== 1 ? ['vip'] : [];
      } else {
        return [];
      }
    }
    // videDuration () {
    //   return (this.currentVideoPlayer && this.currentVideoPlayer.duration) || '';
    // }
  },
  methods: {
    ...mapActions('user', ['getWalletInfo']),
    onRouter (url) {
      this.$router.push(url);
    },
    //  付费
    onDeposit () {
      const isVerify = this.isTourist();
      if (!isVerify) {
        return;
      }
      if (this.videoType === 'video') {
        this.onVideo();
      } else {
        this.onShort();
      }
    },
    //  短视频付费
    onShort () {
      getShortDeductMoney({ id: this.item.id }).then(res => {
        if (res.result === 200000) {
          this.getWalletInfo();
          this.$emit('paySuccess');
        }
      });
    },
    //  影片付费
    onVideo () {
      getVideoDeductMoney({ id: this.item.id }).then(res => {
        if (res.result === 200000) {
          this.getWalletInfo();
          this.$emit('paySuccess');
        }
      });
    },

    //  会员付费
    onVipRight () {
      if (transNumber(this.userInfo.is_vip) === 1 && this.item.is_money === 1) {
        const params = {
          id: this.item.id,
          type: this.type === 'long' ? 2 : 1
        };
        postAddVipVideo(params).then(({ result, msg }) => {
          const isSuccess = result !== 200000;
          if (isSuccess) {
            this.$toast.failed(msg);
          } else {
            //  在解锁成功后，递减用户的观影权益
            if (this.userInfo.video_count > 0) {
              this.userInfo.video_count--;
            }
          }
          this.$emit('onRight', isSuccess);
        });
      }
    },

    //  检测游客账号
    isTourist () {
      if (this.userInfo.is_tourist === 1) {
        Dialog.confirm({
          title: '确认',
          content: '游客账号先绑定手机号及密码?',
          confirmText: '确定',
          onConfirm: () => {
            this.$router.push('/touristBind');
          }
        });
        return false;
      }
      return true;
    }
  }
};
</script>

<template>
  <div class="tip-box">
    <!--  v-show="limit.includes('group')"  -->
    <div class="tip-back">
      <div v-show="limit.includes('group')" class="tip" @click="onRouter(`/userDetail?uid=${item.uid}`)">
        预览{{ item.play_time }}秒, 加入作者粉丝团，免费观看视频 {{ limit.length > 1 ? '' : item.date }}
      </div>
    </div>
    <div v-show="limit.includes('deposit')" class="tip-back">
      <div class="tip" @click="onDeposit">
        预览{{ item.play_time }}秒, 支付{{ item.money }}金币，观看完整版 {{ item.date }}
      </div>
    </div>
    <div v-show="limit.includes('money')" class="tip-back">
      <div class="tip" @click="onRouter('/myWallet')">
        预览{{ item.play_time }}秒, 充值{{ item.money }}金币解锁完整版 {{ item.date }}
      </div>
    </div>
    <div v-show="limit.includes('vip')" class="tip-back">
      <div class="tip" @click="onRouter('/memberRecharge')">
        预览{{ item.play_time }}秒, 充值vip解锁完整版 {{ item.date }}
      </div>
    </div>
    <div v-show="limit.includes('right')" class="tip-back">
      <div class="tip" @click="onVipRight">
        预览{{ item.play_time }}秒, 手动解锁会员免费观看权益 {{ item.date }}
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.tip-box {
  .tip-back {
    background: linear-gradient(90deg, #9B2B44 0%, #427676 100%);
    border-radius: 24px;
    padding: 1px;
    display: inline-block;
    margin-bottom: 6px;
    .tip {
      background: linear-gradient(90deg, #2E8882 0%, #A6213E 100%);
      border-radius: 24px;
      font-family: PingFang SC;
      font-size: 11px;
      font-weight: 500;
      line-height: 11px;
      text-align: center;
      color: #FFFFFF;
      padding: 5px 8px;
    }
  }
}
</style>
